(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('textCropper', function($anchorScroll) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            text: '=',
            htmlSupport: '@',
            maxlength: '@',
            showMoreText: '@',
            showLessText: '@',
            expanded: '@',
            preventCollapse: '=',
            id: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=TextCropper',
        link(scope) {
            scope.maxlength = parseInt(scope.maxlength || 0);
            scope.htmlSupport = scope.htmlSupport === 'true';
            scope.showMore = scope.expanded === 'true';

            scope.more = function(e) {
                e.preventDefault();
                scope.showMore = true;
            };

            scope.less = function(e) {
                e.preventDefault();
                if (!scope.preventCollapse) {
                    scope.showMore = false;
                    scope.scroll();
                }
            };

            scope.scroll = function() {
                const el = document.getElementsByClassName('header-wrapper');
                if (el.length !== 0) {
                    if (scope.id) {
                        $anchorScroll.yOffset = (el[0].clientHeight * 2);
                        $anchorScroll(scope.id);
                    }
                }
            };

            scope.splitText = function() {
                // split the original text into visible and hidden parts
                let visibleText;
                let stop = scope.text.lastIndexOf(' ', scope.maxlength);

                if (stop > 0 && stop <= scope.maxlength) {
                    visibleText = $.trim(scope.text.slice(0, stop));
                }

                const lastChar = visibleText.charAt(visibleText.length);
                if (lastChar === '.' || lastChar === ',') {
                    visibleText = visibleText.slice(0, -1);
                    stop--;
                }

                scope.visiblePart = visibleText;
                scope.hiddenPart = scope.text.slice(stop);
            };

            scope.splitHtml = function() {
                let currentPosition = 0;
                scope.visiblePart = scope.hiddenPart = '';
                scope.htmlContent.children().each((i, el) => {
                    if (currentPosition + el.textContent.length >= scope.maxlength) {
                        scope.hiddenPart = scope.htmlContent.children().slice(i).toArray().reduce((content, el) => content + (el.outerHTML || el.textContent), '');
                        return false;
                    }
                    scope.visiblePart += (el.outerHTML || el.textContent);
                    currentPosition += el.textContent.length;
                });
            };

            scope.$watch('text', t => {
                if (!t) { return; }

                if (scope.htmlSupport) {
                    scope.htmlContent = $('<span/>').html(scope.text);
                }
                scope.cropping = (scope.htmlSupport ?
                    scope.htmlContent[0].textContent.length :
                    scope.text.length) > scope.maxlength;

                if (scope.cropping) {
                    scope[scope.htmlSupport ? 'splitHtml' : 'splitText']();
                }
            });
        }
    };
});
})();
